// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3ymo5","author":"Table_author__2wmz4","authorImage":"Table_authorImage__2Nrfs","unreadRow":"Table_unreadRow__1uY8N"};